import React, { FC } from 'react';
import { UppyUploaderProps } from '@components/common/uppy/types/UppyTypes';

import { UppyUploader } from '@components/common/uppy/UppyUploader';
import { UppyErrorBoundary } from '@components/common/uppy/UppyErrorBoundary';
import { UppyTusWrapper } from './uppy_ucs/UppyTusWrapper';

/**
 * Select uploader component based on feature flags:
 * - Use UppyUploader if `uppy_uploader_features` is enabled or if neither feature is enabled (default).
 * - Use UppyUcsUploader only if `uppy_with_companion_features` is enabled and `uppy_uploader_features` is disabled.
 */
export const UppyFeatureFlagWrapper: FC<UppyUploaderProps> = (props) => {
  const isDefaultUploaderEnabled = BFG.hasFeature('uppy_uploader_features');
  const isUcsUploaderEnabled = BFG.hasFeature('uppy_with_companion_features');

  const UploaderComponent =
    isDefaultUploaderEnabled || !isUcsUploaderEnabled
      ? UppyUploader
      : UppyTusWrapper;

  return (
    <UppyErrorBoundary>
      <UploaderComponent {...props} />
    </UppyErrorBoundary>
  );
};
